import * as yup from 'yup';

import { formUtils } from '../../../../shared/utils';

const { field } = formUtils;

const formSchema = (t, values) => [
  [
    {
      span: 12,
      columns: [field('input', 'name', t, values.name || "", {
        required: true,
        defaultValue: values.name,
        placeholder: t('name.label'),
      }, null)]
    },
    {
      span: 12,
      columns: [field('input', 'email', t, values.email || "", {
        required: true,
        defaultValue: values.email,
        placeholder: t('email.label'),
      }, null)]
    },
    {
      span: 24,
      columns: [field('input', 'organization', t, values.organization || "", {
        required: true,
        defaultValue: values.organization,
        placeholder: t('organization.label'),
      }, null)]
    },
    {
      span: 24,
      columns: [field('textarea', 'message', t, values.message || "", {
        rows: 8,
        required: true,
        placeholder: t('contactPlaceholder'),
        sublabel: t('message.sublabel')
      })]
    }
  ],
];

const validationSchema = t =>
  yup.object().shape({
    name: yup.string().required(t('name.error_required')),
    organization: yup.string().required(t('organization.error_required')),
    email: yup.string().email(t('email.error_invalid')).required(t('email.error_required')),
    message: yup.string().required(t('message.error_required'))
  });

export { formSchema, validationSchema };
